module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = Zz1P
// module chunks = 107